import React, { Component } from 'react';
import './style.scss';

const normalize = (value, min, max) => {
  if (value < min) {
    return min;
  } else if (value > max) {
    return max;
  } else {
    return value;
  }
};

export class Scrubber extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
    };
    this.setValue = this.setValue.bind(this);
  }
  componentDidMount() {
    var newValue;
    const onDrag = (event) => {
      event.preventDefault();
      const { max, onInput } = this.props;
      const { left, width } = this.scrubberContainerRef.getBoundingClientRect();
      const clientX = event && event.touches ? event.touches[0].clientX : event.clientX;
      newValue = normalize(((clientX - left) / width) * max, 0, max);
      this.setState({ value: newValue });
      onInput({ value: newValue });
    };

    const onDragOver = (event) => {
      event.preventDefault();
      document.onmouseup = null;
      document.ontouchend = null;
      document.removeEventListener('mousemove', onDrag);
      document.removeEventListener('touchmove', onDrag);
      const { onInput } = this.props;
      onInput({ value: newValue });
      this.setState({ isPressed: false, isDragging: false });
    };

    const onDragStart = (event) => {
      event.preventDefault();
      document.addEventListener('mousemove', onDrag);
      document.addEventListener('touchmove', onDrag);
      document.onmouseup = onDragOver;
      document.ontouchend = onDragOver;
      onDrag(event);
      this.setState({ isPressed: true, isDragging: true });
    };

    this.scrubberContainerRef.addEventListener('mousedown', onDragStart);
    this.scrubberContainerRef.addEventListener('touchstart', onDragStart);
  }

  setValue(value) {
    if (!this.state.isDragging) {
      this.setState({ value });
    }
  }

  toggleKnob() {
    this.setState({ isPressed: !this.state.isPressed });
  }

  render() {
    const { isPressed, value } = this.state;
    const { max } = this.props;
    return (
      <div
        className={'scrubber-container'}
        ref={(ref) => {
          this.scrubberContainerRef = ref;
        }}>
        <div className={'completed'} style={{ width: `${(value / max) * 100}%` }}></div>
        <div
          ref={(ref) => {
            this.knobRef = ref;
          }}
          className={`knob ${isPressed ? 'pressed' : ''}`}
          style={{ left: `${(value / max) * 100}%` }}></div>
      </div>
    );
  }
}
